"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CRDT_MAJOR_OVERLAY = exports.CRDT_MAJOR = void 0;
var CRDT_MAJOR;
(function (CRDT_MAJOR) {
    CRDT_MAJOR[CRDT_MAJOR["CON"] = 0] = "CON";
    CRDT_MAJOR[CRDT_MAJOR["VAL"] = 1] = "VAL";
    CRDT_MAJOR[CRDT_MAJOR["OBJ"] = 2] = "OBJ";
    CRDT_MAJOR[CRDT_MAJOR["VEC"] = 3] = "VEC";
    CRDT_MAJOR[CRDT_MAJOR["STR"] = 4] = "STR";
    CRDT_MAJOR[CRDT_MAJOR["BIN"] = 5] = "BIN";
    CRDT_MAJOR[CRDT_MAJOR["ARR"] = 6] = "ARR";
})(CRDT_MAJOR || (exports.CRDT_MAJOR = CRDT_MAJOR = {}));
var CRDT_MAJOR_OVERLAY;
(function (CRDT_MAJOR_OVERLAY) {
    CRDT_MAJOR_OVERLAY[CRDT_MAJOR_OVERLAY["CON"] = 0] = "CON";
    CRDT_MAJOR_OVERLAY[CRDT_MAJOR_OVERLAY["VAL"] = 32] = "VAL";
    CRDT_MAJOR_OVERLAY[CRDT_MAJOR_OVERLAY["VEC"] = 96] = "VEC";
    CRDT_MAJOR_OVERLAY[CRDT_MAJOR_OVERLAY["OBJ"] = 64] = "OBJ";
    CRDT_MAJOR_OVERLAY[CRDT_MAJOR_OVERLAY["STR"] = 128] = "STR";
    CRDT_MAJOR_OVERLAY[CRDT_MAJOR_OVERLAY["BIN"] = 160] = "BIN";
    CRDT_MAJOR_OVERLAY[CRDT_MAJOR_OVERLAY["ARR"] = 192] = "ARR";
})(CRDT_MAJOR_OVERLAY || (exports.CRDT_MAJOR_OVERLAY = CRDT_MAJOR_OVERLAY = {}));
